import React from "react";
import Layout from "../components/Layout";

export default function Dashboard() {
  return (
    <Layout>
      <h2>Welcome to your Dashboard</h2>
      <p>Select an option from the sidebar to manage your interviews.</p>
    </Layout>
  );
}
